export const FieldsGetHeadings = fields =>
    fields.map(({ title, field, type, sortField, ...rest }) => ({
        value: title,
        field: dashboardDataGetField(type, field),
        sortField: sortField || field,
        ...rest
    }));

export const dashboardDataGetField = (type, field) => (type ? `${field}_${type}` : field);
